import { Box, Button, Typography } from '@mui/material'
import { ReactElement } from 'react'
import { useNavigate } from 'react-router-dom'
import theme from 'src/theme'

export default (): ReactElement => {
  let navigate = useNavigate()

  return (
    <Box sx={{ m: -3, backgroundColor: 'background.default' }}>
      <Box
        sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}
      >
        <Box
          sx={{
            flex: '1 0 200px',
            maxWidth: 400,
            boxShadow: `0 0 200px 0 ${theme.palette.background.paper}`,
          }}
        >
          <img style={{ width: '100%', height: 'auto' }} src="/404-error.png" />
        </Box>
      </Box>
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          mt: 1,
        }}
      >
        <Typography sx={{ my: 1 }}>This page does not exist.</Typography>
        <Button variant="contained" onClick={() => navigate('/self-paced')}>
          Return to Home Page
        </Button>
      </Box>
    </Box>
  )
}
